"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Modal = require("./Modal");
var _Popup = require("../Popup");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var show = function show(config) {
  var div = document.createElement('div');
  var currentConfig = _objectSpread(_objectSpread({}, config), {}, {
    active: true
  });
  document.body.appendChild(div);
  var render = function render(props) {
    var container = document.querySelector("#".concat(props.rootId, " #").concat((0, _getPrefixCls.getPrefixCls)('container'))) || undefined;
    var Comp = props.type === 'popup' ? _Popup.Popup : _Modal.Modal;
    setTimeout(function () {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(Comp, (0, _extends2.default)({}, props, {
        container: container,
        onClose: close
      }), props.children), div);
    });
  };
  var update = function update(configUpdate) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = _objectSpread(_objectSpread({}, currentConfig), configUpdate);
    }
    render(currentConfig);
  };
  var unmount = function unmount() {
    var unmountResult = _reactDom.default.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  };
  var close = function close() {
    currentConfig = _objectSpread(_objectSpread({}, currentConfig), {}, {
      active: false
    });
    render(currentConfig);
    unmount();
  };
  render(currentConfig);
  return {
    update: update,
    destroy: close
  };
};
exports.show = show;